import { init } from '@resuelve/malinchex'

const malinchexInit = (locale) => {
  const server = process.env.REACT_APP_MALINCHEX_SERVER
  return init(server, locale)
}

export default malinchexInit
